import styled from "styled-components";
import { TextColorNames } from "@smartsuite/types";

export const Option = styled.div`
  font-size: 15px;
  display: inline-block;
  margin: 7px;
  svg,
  span {
    display: inline-block;
    justify-content: center;
    align-items: center;
  }

  svg {
    margin-right: 10px;
  }
`;

export const ReactInputFieldContainer = styled.div`
  padding: 0 0px 14px;
  position: relative;
`;

export const InputLabel = styled.label`
  font-style: normal;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  display: inline-flex;
  align-items: center;
  padding-right: 1px;
  color: ${TextColorNames.primary};
`;

export const InputSubLabel = styled.label`
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: ${TextColorNames.secondary};
  margin-bottom: 9px;

  b {
    color: ${TextColorNames.primary};
  }
  a {
    color: ${TextColorNames.secondary};
  }
`;
